module.exports = __webpack_public_path__ + "img/31_BF9_travel_mentally.ec66056e.jpg";